import { useAuthContext } from 'src/auth/hooks';

export function useIsAmcRequired() {
  const { user } = useAuthContext();
  return user?.company?.isAmcRequired ?? false;
}
